import { render, staticRenderFns } from "./SchoolInstrument.vue?vue&type=template&id=6b8db3dc&scoped=true&"
import script from "./SchoolInstrument.vue?vue&type=script&lang=js&"
export * from "./SchoolInstrument.vue?vue&type=script&lang=js&"
import style0 from "./SchoolInstrument.vue?vue&type=style&index=0&id=6b8db3dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8db3dc",
  null
  
)

export default component.exports